import { UpdateImageTypes } from "../interfaces/products.interface";

class ProductService {
  async updateProductImage({ id, image, token }: UpdateImageTypes) {
    const imageData = new FormData();
    imageData.append("product_photo", image);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_HOST}/api/products/product/${id}/patch-photo/`,
        {
          method: "PATCH",
          body: imageData,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (!response.ok) {
        throw Error;
      }
    } catch (error) {
      throw new Error("Αποτυχία ενημέρωσης φωτογραφίας");
    }
  }

  async syncProducts(
    token: string,
    setStartSyncCheck: React.Dispatch<React.SetStateAction<boolean>>,
  ) {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_HOST}/api/products/erp-sync/start/`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (!response.ok) {
        throw Error;
      }
      setStartSyncCheck(true);
    } catch (error) {
      setStartSyncCheck(false);
      throw new Error("Αποτυχία συγχρονισμού προιοντων");
    }
  }
  async syncProductsStatus(token: string) {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_HOST}/api/products/erp-sync/status/`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (!response.ok) {
        throw Error;
      }

      return response.json();
    } catch (error) {
      throw new Error("Αποτυχία συγχρονισμού προιοντων");
    }
  }
}
export default new ProductService();
